import { LinkComponentType } from '@bm-js/atlascloud-ui'

const LinkComponent: LinkComponentType = (props) => {
  const { editorClick, onClick, children, className } = props
  return (
    <a
      href='#'
      onClick={(e) => {
        e.preventDefault()
        if (editorClick) editorClick()
        if (onClick) onClick()
      }}
      className={className}
    >
      {children}
    </a>
  )
}

export default LinkComponent
